export default __webpack_public_path__ + "static/media/animal03.60ecbfa4.png";